import { observable } from "mobx";
import { Type } from "class-transformer";
import ExemptionRegistrationMethod from "./exemptionRegistrationMethod";
import ExemptionPermittedActionsResponse from "./exemptionPermittedActionsResponse";
import VehicleResponse from "./vehicleResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionResponse {
  /**
   * Exemption ID.
   */
  @observable
  exemptionId!: string;

  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  /**
   * Exemption reason ID.
   */
  @observable
  exemptionReasonId!: string;

  /**
   * Creation record ID.
   */
  @observable
  creationRecordId?: string;

  @observable
  creationMethod!: ExemptionRegistrationMethod;

  /**
   * Exemption was created at this date and time.
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;

  /**
   * Cancellation official record ID.
   */
  @observable
  cancellationRecordId?: string;

  @observable
  officialRecordId?: string;

  @observable
  cancellationMethod?: ExemptionRegistrationMethod;

  /**
   * Cancellation reason.
   */
  @observable
  cancellationReason?: string;

  /**
   * Vehicle registration change official record ID.
   */
  @observable
  vehicleRegistrationChangeRecordId?: string;

  /**
   * Vehicle registration change submission date.
   */
  @observable
  @Type(() => Date)
  vehicleRegistrationChangeSubmissionDate?: Date;

  /**
   * Exemption is valid since this date and time.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * Exemption is valid until this date and time.
   */
  @observable
  @Type(() => Date)
  validUntil?: Date;

  @observable
  @Type(() => ExemptionPermittedActionsResponse)
  permittedActions!: ExemptionPermittedActionsResponse;
}
